import { provinceRoute } from "@/routing/routes";
import { ContactPage } from ".";
import { createRoute } from "@tanstack/react-router";

const index = createRoute({
  path: "contact",
  getParentRoute: () => provinceRoute,
  component: ContactPage,
});

export const contactRoutes = index;
